import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_avatar = _resolveComponent("q-avatar")!

  return (_openBlock(), _createBlock(_component_q_avatar, {
    size: _ctx.avatarSize,
    class: "bot-avatar"
  }, {
    default: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.avatar,
        alt: "avatar"
      }, null, 8, _hoisted_1),
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "background bg-primary" }, null, -1))
    ]),
    _: 1
  }, 8, ["size"]))
}